<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    :before-close="handleClose"
    custom-class="codeDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :destroy-on-close="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">银行卡支付</div>
        <fm-button
          type="info"
          size="mini"
          text
          icon="icon-model-close"
          @click="handleClose"
        ></fm-button>
      </div>
      <div class="d-content">
        <div class="card-input-group">
          <div class="topBox">
            <span class="fot">支持的银行卡</span>
            <div class="imgList">
              <img
                v-for="(item, index) in imgList"
                :key="index"
                :src="$utils.getPng(item)"
                class="imgL"
              />
            </div>
          </div>
          <div class="card-box">
            <span class="titleN" v-show="showTitle">卡号</span>
            <div
              class="card-input-one"
              id="cardNumber"
              :class="inputClassObj"
            ></div>
          </div>

          <div class="btBox">
            <div class="card-box">
              <span class="titleN" v-show="showTitle">有效期</span>
              <div id="expiry" class="twoInput" :class="inputClassObj"></div>
            </div>
            <div class="line"></div>
            <div class="card-box">
              <span class="titleN" v-show="showTitle">安全码</span>
              <div id="cvc" class="threeInput" :class="inputClassObj"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-footer">
        <div class="leftBox">
          <span class="leftFont">实付:</span>
          <span class="price">￥{{ cardPayList.new_real_price }}</span>
        </div>
        <fm-button
          :disabled="!checkPay"
          @click="confirm"
          type="primary"
          size="small"
          >确认支付</fm-button
        >
      </div>
    </div>
    <div v-if="loading" v-loading="loading" class="flxed"></div>
  </el-dialog>
</template>

<script>
import { getOrderStateAPI, generatePaySignAPI } from '@/utils/apiList/vip.js'
export default {
  name: 'PayPal',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    cardPayList: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      inputClassObj: {
        'card-input': true,
        'card-border': false,
      },
      checkPay: false,
      showTitle: false, //展不展示标题
      loading: false,
      elements: {
        cardNumber: null,
        expiry: null,
        cvc: null,
      },
      count: 0,
      eventHandlers: {
        // 存储所有事件处理器引用
        change: null,
        ready: null,
      },
      isEventsBound: false, // 事件绑定状态标志
      imgList: [
        'icon-vip-visa',
        'icon-vip-jcb',
        'icon-vip-unionpay',
        'icon-vip-maestro',
      ],
      isMounted: false,
    }
  },
  watch: {
    isShow(newVal) {
      if (newVal) {
        this.initCard()
      }
    },
  },
  methods: {
    async initCard() {
      try {
        // 等待SDK就绪
        this.loading = true
        await this.waitForSDK()

        // 获取预加载元素 仅首次初始化时执行
        if (!this.isMounted) {
          const { elements } = window.AirwallexSDK
          this.elements = elements
          // 挂载元素
          await Promise.all([
            elements.cardNumber.mount('cardNumber'),
            elements.expiry.mount('expiry'),
            elements.cvc.mount('cvc')
          ])
          // 绑定原有事件
          this.bindEvent()
          this.isMounted = true
        }

        // 触发样式更新
        this.$nextTick(() => {
          this.inputClassObj['card-border'] = true
          this.showTitle = true
        })
      } catch (error) {
        // console.error('支付组件初始化失败:', error)
      }
    },

    // 绑定事件
    bindEvent() {
      // 先完全解绑旧事件，避免重复绑定
      this.unbindEvent()

      const elementsCompleted = {
        cardNumber: false,
        expiry: false,
        cvc: false,
      }

      const elementArray = [
        this.elements.cardNumber,
        this.elements.expiry,
        this.elements.cvc,
      ]

      // 创建统一的事件处理器（避免匿名函数）
      this.eventHandlers = {
        change: (event, index) => {
          const { type, complete } = event.detail
          if (elementsCompleted.hasOwnProperty(type)) {
            elementsCompleted[type] = complete
          }

          this.checkPay = !Object.values(elementsCompleted).includes(false)
          // 自动切换焦点逻辑
          // if (complete) {
          //   const nextIndex = index + 1
          //   if (nextIndex < elementArray.length) {
          //     elementArray[nextIndex].focus()
          //   }
          // }
        },
        ready: () => {
          this.count++
          if (this.count === 3) {
            this.count = 0
            this.loading = false
          }
        },
      }

      // 绑定新事件
      elementArray.forEach((element, index) => {
        element.on('change', e => this.eventHandlers.change(e, index))
        element.on('ready', this.eventHandlers.ready)
      })

      this.isEventsBound = true
    },

    // 解绑方法
    unbindEvent() {
      if (!this.elements || !this.isEventsBound) return
      ;[
        this.elements.cardNumber,
        this.elements.expiry,
        this.elements.cvc,
      ].forEach(element => {
        if (element) {
          element.off('change')
          element.off('ready')
        }
      })

      this.isEventsBound = false
    },

    // 等待SDK就绪
    waitForSDK() {
      return new Promise((resolve, reject) => {
        if (window.AirwallexSDK?.isReady) return resolve()
        const checkInterval = setInterval(() => {
          if (window.AirwallexSDK?.isReady) {
            clearInterval(checkInterval)
            resolve()
          }
        }, 50)
        setTimeout(() => {
          clearInterval(checkInterval)
          reject(new Error('SDK加载超时'))
        }, 5000)
      })
    },

    // 银行卡支付方法
    confirm: _.debounce(
      async function () {
        if (!this.checkPay) {
          return
        }
        let res = await generatePaySignAPI(this.cardPayList)
        // console.log('res', res)
        if (res.status == 1) {
          this.loading = true
          try {
            let data = {
              intent_id: res.data.payment_intent_id,
              client_secret: res.data.client_secret,
            }
            // console.log('银行卡支付参数', data)
            const response = await this.elements.cardNumber.confirm(data)

            if (response.error) {
              // console.log('确认支付时出错:', response.error)
              this.loading = false
              this.$toast(response.message, 2)
            } else {
              // console.log('支付成功:', response)
              clearInterval(this.payTimer)
              let list = {
                out_trade_no: res.data.out_trade_no,
                pay_type: res.data.pay_type,
                pay_id: this.cardPayList.pay_id,
              }
              this.payTimer = setInterval(() => {
                this.checkOrder(list)
              }, 4000)
            }
          } catch (error) {
            // console.log('支付过程中出现错误:', error)
            this.loading = false
            this.$toast(error.message, 2)
          }
        } else if (res.status == 50013) {
          this.$toast(res.msg, 2)
        } else if (res.status == 0) {
          this.$toast(res.msg, 4)
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    checkOrder: _.debounce(
      function (code) {
        //除了 wxpay 全部是 alipay
        let order = {
          order_id: code.out_trade_no,
          pay_type: code.pay_type,
          pay_id: code.pay_id, // 会员id
        }
        getOrderStateAPI(order)
          .then(res => {
            //已失效 超过三分钟失效
            if (res.status == 2) {
              clearInterval(this.payTimer)
              this.loading = false
            }
            // 支付成功
            if (res.status == 1) {
              this.$emit('openSuccess', res.data.pay_toast)
              clearInterval(this.payTimer)
              this.handleClose()
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      100,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    handleClose() {
      this.count = 0
      this.checkPay = false,
      this.loading = false
      clearInterval(this.payTimer)
      this.$emit('handleClose')
    },
  },
}
</script>

<style lang="scss" scoped>
.codeDialog {
  .flxed {
    width: 100%;
    height: 100%;
    background: transparent;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 16px;
    ::v-deep .el-loading-mask {
      border-radius: 16px;
    }
  }
  .left {
    height: 24px;
    font-weight: 500;
    font-size: 16px;
    @include useTheme {
      color: getVar('text-color2-2c2c2c');
    }
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .d-footer {
    // margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .leftBox {
      display: flex;
      align-items: flex-end;
      .leftFont {
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        margin-right: 2px;
        margin-bottom: 4px;
        @include useTheme {
          color: getVar('text-color1-8a8b92');
        }
      }
    }
    .price {
      font-weight: 600;
      font-size: 24px;
      color: #f67942;
      line-height: 32px;
    }
  }
  .d-content {
    width: 480px;
    margin-left: -24px;
    margin-top: 16px;
    @include useTheme {
      box-shadow: getVar('news-box-shadow3');
    }
    .card-input-one {
      width: 100% !important;
      margin-bottom: 32px;
    }
    .card-input-group {
      min-height: 192px;
      padding: 20px 24px 32px 24px;
      .topBox {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 32px;
        .fot {
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 8px;
          @include useTheme {
            color: getVar('text-color2-2c2c2c');
          }
        }
        .imgList {
          display: flex;
          justify-content: center;
          align-items: center;
          .imgL {
            width: 40px;
            height: 28px;
            margin-right: 16px;
            object-fit: cover;
          }
        }
      }
      .card-box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .titleN {
          font-weight: 400;
          font-size: 12px;
          white-space: nowrap;
          line-height: 20px;
          margin-bottom: 4px;
          @include useTheme {
            color: getVar('text-color2-2c2c2c');
          }
        }
      }
    }
    .line {
      width: 20px;
    }
    .btBox {
      display: flex;
      width: 100%;
      white-space: nowrap;
      .twoInput {
        width: 206px !important;
        margin-right: 20px;
      }
      .threeInput {
        width: 206px !important;
      }
    }
    .card-input {
      width: 100%;
      height: 40px;
      padding-left: 16px;
      border-radius: 8px;
      display: flex;
      align-items: center;
    }
    .card-border {
      line-height: 22px;
      border-radius: 8px;
      border: 1px solid transparent;
      @include useTheme {
        background: getVar('text-color1-f6f6f6');
        color: getVar('text-color2-2c2c2c');
      }
      &:hover {
        border: 1px solid $primary-color;
      }
      &:focus {
        border: 1px solid $primary-color;
        @include useTheme {
          background: getVar('bg-color');
          color: getVar('text-color1-2c2c2c');
        }
      }
    }
  }
}
</style>
<style lang="scss">
iframe {
  transition: none !important;
}
</style>
